var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "place-floor-plans", attrs: { fluid: "" } },
    [
      _c("page-title-area", [
        _c("h1", [_vm._v(_vm._s(_vm.place ? _vm.place.name : ""))]),
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
        : [
            _vm.pollingForNewFloorPlan
              ? _c("polling-channel", {
                  attrs: {
                    input: _vm.pollingState,
                    active: _vm.pollingForNewFloorPlan,
                    updateFunction: _vm.checkForNewFloorPlan,
                    interval: _vm.POLLING_INTERVAL_MS,
                  },
                  on: { valueUpdated: _vm.onFloorPlanPollingUpdate },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("floor-plan-toolbar", {
              staticClass: "floor-plan-toolbar",
              attrs: {
                "current-floor-plan": _vm.currentFloorPlan,
                "all-floor-plans": _vm.allFloorPlans,
                "selected-month": _vm.selectedMonth,
                "display-mode": _vm.displayMode,
                "detection-filter": _vm.detectionFilter,
                "loading-events": _vm.loadingEvents,
                "has-unsaved-changes": _vm.hasUnsavedChanges,
                saving: _vm.saving,
                deleting: _vm.deleting,
                exporting: _vm.exporting,
              },
              on: {
                change: _vm.handleFloorPlanSwitch,
                "save-name": _vm.handleSaveName,
                save: _vm.saveChanges,
                cancel: _vm.cancelChanges,
                add: _vm.triggerFileInput,
                delete: _vm.handleDelete,
                download: _vm.handleDownload,
                "month-change": _vm.handleMonthChange,
                "display-mode-change": function ($event) {
                  _vm.displayMode = $event
                },
                "detection-filter-change": function ($event) {
                  _vm.detectionFilter = $event
                },
              },
            }),
            _vm._v(" "),
            _vm.isUploadingFloorPlan
              ? _c(
                  "v-alert",
                  { staticClass: "mb-4", attrs: { type: "info", dense: "" } },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("msg.uploading")) + "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.capturePlacementMode
              ? _c("div", { staticClass: "placement-backdrop" })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  {
                    class: {
                      "placement-mode-canvas": _vm.capturePlacementMode,
                    },
                    attrs: { cols: "12", md: "8" },
                  },
                  [
                    _vm.currentFloorPlan
                      ? _c("floor-plan-canvas", {
                          ref: "floorPlanCanvas",
                          attrs: {
                            "floor-plan": _vm.currentFloorPlan,
                            items: _vm.items,
                            sensors: _vm.sensors,
                            "capture-items": _vm.captureItemsForCanvas,
                            "capture-placement-mode": _vm.capturePlacementMode,
                            "display-mode": _vm.displayMode,
                            "place-name": _vm.place ? _vm.place.name : "",
                            "selected-month": _vm.selectedMonth,
                            "detection-filter": _vm.detectionFilter,
                            "sensor-events": _vm.sensorEvents,
                            "is-exporting": _vm.exporting,
                          },
                          on: {
                            change: _vm.handleFloorPlanChange,
                            "capture-change": _vm.handleCaptureRecordChange,
                            "capture-place": _vm.handleCapturePlaceClick,
                            "capture-click": _vm.handleCaptureRecordPinClick,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.currentFloorPlan
                      ? _c("empty-floor-plan-state", {
                          on: { upload: _vm.triggerFileInput },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-col",
                  { attrs: { cols: "12", md: "4" } },
                  [
                    _c("side-panel", {
                      attrs: {
                        items: _vm.items,
                        "capture-records": _vm.captureRecords,
                        "current-floor-plan-id": _vm.currentFloorPlan
                          ? _vm.currentFloorPlan.id
                          : null,
                        "all-floor-plans": _vm.allFloorPlans,
                        sensors: _vm.sensors,
                        "floor-plan-objects": _vm.currentFloorPlan
                          ? _vm.currentFloorPlan.objects || {}
                          : {},
                        "place-name": _vm.place ? _vm.place.name : "",
                        "floor-plan-name": _vm.currentFloorPlan
                          ? _vm.currentFloorPlan.name
                          : "",
                        "selected-month": _vm.selectedMonth,
                        "detection-filter": _vm.detectionFilter,
                      },
                      on: {
                        remove: _vm.handleRemoveItem,
                        "capture-edit": _vm.handleCaptureRecordEdit,
                        "capture-delete": _vm.handleCaptureRecordDelete,
                        "capture-unplace": _vm.handleCaptureRecordUnplace,
                        "capture-add-from-map": _vm.handleAddFromMap,
                        "capture-add-without-position":
                          _vm.handleAddWithoutPosition,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("input", {
              ref: "fileInput",
              staticClass: "d-none",
              attrs: {
                type: "file",
                accept: "image/jpeg,image/png",
                "data-testid": "floor-plan-file-input",
              },
              on: { change: _vm.handleFileSelected },
            }),
            _vm._v(" "),
            _vm.featureIsActive("r_type_capture_record")
              ? _c("capture-record-editor", {
                  attrs: {
                    record: _vm.editingCaptureRecord,
                    sensors: _vm.sensors,
                    "place-id": _vm.placeId,
                    "default-sensor-ids": _vm.defaultSensorIds,
                  },
                  on: { saved: _vm.handleCaptureRecordSaved },
                  model: {
                    value: _vm.showCaptureRecordEditor,
                    callback: function ($$v) {
                      _vm.showCaptureRecordEditor = $$v
                    },
                    expression: "showCaptureRecordEditor",
                  },
                })
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }